import "./App.css";
import Routes from "./Routes";
import React from "react";
import {ReactSession} from 'react-client-session';
import {ThemeProvider} from '@mui/styles';
import theme from "./theme";


function App() {
    ReactSession.setStoreType("localStorage");
    return (
        <ThemeProvider theme={theme}>
            <Routes/>
        </ThemeProvider>
    );

}


export default App;

/*
<Navbar collapseOnSelect bg="light" expand="md" className="mb-3">
                <Navbar.Brand className="font-weight-bold text-muted">
                    Scratch
                </Navbar.Brand>
                <Navbar.Toggle />
            </Navbar>
 */
